import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { copy } from "../data/copy";
import { buildWhatsAppUrl, WHATSAPP_NUMBER } from "../context/CartContext";
import { BUSINESS } from "../data/copy";

export const Contact = () => {
    const { t, lang } = useLang();
    const wa = buildWhatsAppUrl("Hello Kumari Pickles");

    return (
        <section
            id="contact"
            className="relative py-24 md:py-32 bg-[color:var(--kp-cream)]"
            data-testid="contact-section"
        >
            <div className="max-w-[1300px] mx-auto px-6 md:px-10">
                <div className="card-warm p-8 md:p-14 relative overflow-hidden" style={{ background: "var(--kp-turmeric)" }}>
                    <div
                        className="absolute -top-20 -right-20 w-72 h-72 rounded-full opacity-40"
                        style={{ background: "radial-gradient(circle, var(--kp-terracotta) 0%, transparent 70%)" }}
                    />
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center relative z-10">
                        <div>
                            <div className="inline-flex items-center gap-2 text-[11px] tracking-mono-wide text-[color:var(--kp-terracotta-deep)] mb-4">
                                {t(copy.contact.eyebrow)}
                            </div>
                            <motion.h2
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1] }}
                                className={`text-5xl md:text-6xl leading-[0.98] font-bold text-[color:var(--kp-ink)] mb-4 ${
                                    lang === "te" ? "font-telugu-display" : "font-display"
                                }`}
                                data-testid="contact-title"
                            >
                                {t({ en: "One message,", te: "ఒక్క సందేశం," })}
                                <br />
                                <em className="italic text-[color:var(--kp-terracotta-deep)] font-medium">
                                    {t({ en: "fresh from the kitchen.", te: "వంటగది నుండి." })}
                                </em>
                            </motion.h2>
                            <p className={`text-lg text-[color:var(--kp-ink)]/80 max-w-md ${lang === "te" ? "font-telugu-body" : "font-body"}`}>
                                {t(copy.contact.body)}
                            </p>
                        </div>
                        <div className="flex flex-col gap-3">
                            <a href={wa} target="_blank" rel="noopener noreferrer" className="btn-warm justify-between" data-testid="contact-whatsapp">
                                <span className="flex items-center gap-2">
                                    <MessageCircle size={16} />
                                    {t(copy.contact.whatsapp)}
                                </span>
                                <span>→</span>
                            </a>
                            <a
                                href={`tel:+${WHATSAPP_NUMBER}`}
                                className="btn-outline-warm justify-between"
                                data-testid="contact-phone"
                            >
                                <span className="flex items-center gap-2">
                                    <Phone size={16} />
                                    {t(copy.contact.phone)}
                                </span>
                                <span className="font-display text-base">{BUSINESS.phone_display}</span>
                            </a>
                            <div className="mt-3 text-sm text-[color:var(--kp-ink)]/85 space-y-2 bg-[color:var(--kp-cream)]/60 rounded-2xl p-4">
                                <div className="font-bold text-[color:var(--kp-terracotta-deep)]" data-testid="talk-to-us">
                                    {t(copy.products.talk)}
                                </div>
                                <div data-testid="customise-note">
                                    {t(copy.products.customise)}
                                </div>
                            </div>
                            <div className="mt-2 text-sm text-[color:var(--kp-ink)]/75 space-y-1">
                                <div className="font-bold">{t({ en: "Kitchen hours", te: "వంటగది సమయాలు" })}</div>
                                <div>{t(BUSINESS.hours)}</div>
                                <div>{t(BUSINESS.address)}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
